type SortableShopProductVariant = {
  image?: {
    baseUrl?: string | null;
    mediaPath?: string | null;
  } | null;
  inventory?: {
    availability?: string | null;
  } | null;
};
export const hasChicletImage = (variant: SortableShopProductVariant) => Boolean(variant.image?.baseUrl && variant.image?.mediaPath);
export const isOutOfStock = (variant: SortableShopProductVariant) => variant.inventory?.availability === 'OUT_OF_STOCK';

/**
 * Sort variants with in-stock items first while preserving all variants.
 */
export const sortShopProductVariants = <T extends SortableShopProductVariant,>(variants: T[] | null | undefined): T[] => [...(variants ?? [])].sort((a, b) => {
  const aOutOfStock = isOutOfStock(a);
  const bOutOfStock = isOutOfStock(b);
  if (aOutOfStock === bOutOfStock) return 0;
  return aOutOfStock ? 1 : -1;
});